module.exports = __webpack_public_path__ + "static/media/payment.915d24cc.svg";